export const APPLY_COUPON = "APPLY_COUPON";
